const DEFAULTS = {
  config: {
    alignment: "center",
    size: "content",
    link: {
      target: "_blank",
      rel: ""
    }
  }
};
const EMBED_DEFAULTS = {
  containerData: {
    alignment: "CENTER",
    textWrap: true,
    width: {
      custom: 350
    }
  }
};

export { DEFAULTS, EMBED_DEFAULTS };
//# sourceMappingURL=defaults.js.map
